// extracted by mini-css-extract-plugin
module.exports = {"container":"e9","image":"e-","title":"e_","desc":"fa"};